module.exports = __webpack_public_path__ + "static/media/p18.b8e3596d.jpeg";